import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AzureAD, { IAzureADFunctionProps } from "react-aad-msal";
import { Box, Grid } from "@material-ui/core";

import { LoadingNotification } from "../components/common/LoadingNotification";
import { NotificationSnackbar } from "../components/common/NotificationSnackbar";
import { LoadingState } from "../state/loadingState";
import { createBatch, resetCreate } from "../state/createBatch";
import { BatchFormData } from "../model/batch";
import { UserGroup } from "../model/user";
import { RootState, useAppDispatch } from "../reduxStore";
import { authProvider } from "../authProvider";
import { Unauthorized } from "./Unauthorized";
import { clearMessage } from "../state/messages";
import { NewBatchForm } from "../components/form/NewBatchForm";
import { Heading } from "../components/common/Heading";

const AddBatch = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const userGroups = useSelector((state: RootState) => state.userGroups.userGroups);
  const loading = useSelector((state: RootState) => state.userGroups.loading);
  const isAuthorized = userGroups?.includes(UserGroup.WAREHOUSE_PERSONNEL_GROUP);

  const batchCreated = useSelector((state: RootState) => state.batches.create.batch);
  const batchCreating = useSelector((state: RootState) => state.batches.create.creating);
  const batchCreateError = useSelector((state: RootState) => state.batches.create.error);

  useEffect(() => {
    if (batchCreated && batchCreating === LoadingState.Succeeded) {
      history.push("/list");
    }
    return () => {
      dispatch(resetCreate());
    };
  }, [batchCreated, batchCreating, history, dispatch]);

  if (!isAuthorized && loading === LoadingState.Succeeded) return <Unauthorized />;
  return (
    <Box>
      <Grid container direction="row">
        <Grid container item xs alignItems="center" justify="flex-start">
          <Heading variant="h2" returnTo="/list">
            Uusi saapumiserä
          </Heading>
        </Grid>
      </Grid>

      {loading === LoadingState.Pending && <LoadingNotification />}
      <AzureAD provider={authProvider} forceLogin={false}>
        {({ accountInfo, error: authError }: IAzureADFunctionProps) => (
          <Box>
            <NewBatchForm
              handleSave={(values: BatchFormData) =>
                dispatch(createBatch({ batch: values, userName: accountInfo?.account.userName || "NO USER" }))
              }
              error={batchCreateError}
              isSaving={batchCreating === LoadingState.Pending}
            />
            <NotificationSnackbar
              text={authError?.errorMessage}
              severity="error"
              onClosed={() => dispatch(clearMessage())}
            />
          </Box>
        )}
      </AzureAD>
    </Box>
  );
};

export default AddBatch;
